import { TLang } from 'src/constants/langs'
import { LocalizedText } from 'src/types/common/localized'
import { getLocalizedText } from '../getLocalizedText'

export function useLocalizedText<T extends boolean = false>(
    lang: TLang,
    texts: Record<TLang, LocalizedText<T>>
): LocalizedText<T> {
    return getLocalizedText(lang, texts)
}
